export var claimSystemParameterName = "claim-system-id";
export var loadConfigurationParameterName = "ovmconfigid";
export var googleAnalyticsEvents = {
    click: {
        runSimulation: "ovm_run_simuation",
        save: "ovm_save",
        summaryOrder: "ovm_summary_order",
        copyLink: "ovm_sharable_link_copy",
        downloadSystemPerformance: "ovm_download_sys_perf_desc",
        contactUs: "ovm_contact_us_click",
    },
    taskDone: {
        calculation: "ovm_simulation_completed",
    },
};
